module.exports = __webpack_public_path__ + "static/media/img5.c95d0897.jpg";